import ProductImageSec from "./ProductImageSec";

export default ProductImageSec;
